import {List} from 'src/design/atoms/List';
import {Stack} from 'src/design/atoms/Stack';
import {MIME_TYPES} from '@mantine/dropzone';
import React from 'react';
import type {IFormDocumentUploadFile} from 'src/app/forms/FormFileDropzone/FormFileUploadV2';
import {FormFileUploadV2} from 'src/app/forms/FormFileDropzone/FormFileUploadV2';
import {InfoAlert} from 'src/design/molecules/InfoAlert';
import type {IFormFieldV2} from 'src/types/FormV2';
import {ColumnGuide} from './ColumnGuide';

const STANDARD_FIELD: IFormFieldV2 = {
  name: 'personnelImport',
  label: 'Personnel File Upload',
  type: 'file',
  description:
    'Select a .CSV file containing your personnel data. Column headers are matched by name, in any order.',
  fileUploadOptions: {
    allowedFileTypes: [MIME_TYPES.csv],
    isHideUploadSuccessEnabled: true,
    maxFileSize: 10240000,
  },
};

const ZF_FIELD: IFormFieldV2 = {
  name: 'personnelImport',
  label: 'Personnel File Upload',
  type: 'file',
  description:
    'Select a ZF personnel XLS file exported from PeopleSoft. Standard XLS and XLSX files are not accepted. To build the file manually, modify the PeopleSoft export, save it as CSV, then rename the extension to .xls.',
  fileUploadOptions: {
    allowedFileTypes: [MIME_TYPES.xls],
    isHideUploadSuccessEnabled: true,
    maxFileSize: 10240000,
  },
};

export interface UploadStepProps {
  files: IFormDocumentUploadFile[];
  isZfEmployeeImport: boolean;
  onFilesChange: (files: IFormDocumentUploadFile[]) => void;
}

export const UploadStep: React.FC<UploadStepProps> = ({
  files,
  isZfEmployeeImport,
  onFilesChange,
}) => (
  <Stack gap="md">
    <InfoAlert title="Before you upload">
      <List size="sm">
        <List.Item>
          New people are created and existing people are updated, matched by
          Employee ID first, then by email address.
        </List.Item>
        <List.Item>
          Nothing is saved until you review the file and confirm the import on
          the next step.
        </List.Item>
        <List.Item>
          A results email is sent to you when the import job finishes.
        </List.Item>
      </List>
    </InfoAlert>

    {!isZfEmployeeImport && <ColumnGuide />}

    <FormFileUploadV2
      field={isZfEmployeeImport ? ZF_FIELD : STANDARD_FIELD}
      value={files}
      onChange={(_name, _value, uploadedFiles) => onFilesChange(uploadedFiles)}
    />
  </Stack>
);
